import enTranslations from './en.json';
import arTranslations from './ar.json';

// Type for available languages
export type Language = 'en' | 'ar';

// Type for translation records
export type TranslationRecord = {
  [key: string]: string;
};

/**
 * Translations object containing all languages.
 * The keys are kebab-case identifiers (e.g., 'page-not-found')
 * rather than the actual English text.
 */
export const translations: Record<Language, TranslationRecord> = {
  en: enTranslations,
  ar: arTranslations
};

/**
 * Helper function to get translations for a specific language.
 * 
 * @param language - The language code ('en' or 'ar')
 * @returns The translation record for the specified language
 */
export const getTranslations = (language: Language): TranslationRecord => {
  return translations[language] || translations['en']; // Default to English if language not found
};

// Export individual translation files for direct access if needed
export { default as enTranslations } from './en.json';
export { default as arTranslations } from './ar.json'; 